module.exports = __webpack_public_path__ + "img/2.cleaned_toilet.55009f17.svg";